module.exports = __webpack_public_path__ + "static/media/neuro-invoice-sample.b7f6545f.jpg";